<template>
	<div class="salesforce-credentials-form">
		<TextField
			:value="secret"
			label="Password *"
			placeholder="Enter password"
			class="mb-3"
			:rules="{ required: true }"
			@input="$emit('update:secret', $event)"
		/>
		<TextField
			:value="salt"
			label="Salt *"
			placeholder="Enter salt value (hexadecimal, min 16 characters)"
			class="mb-3"
			:rules="{ required: true, hexSalt }"
			@input="$emit('update:salt', $event)"
		/>
		<TextField
			:value="iv"
			label="Initialization Vector (IV) *"
			placeholder="Enter IV value (hexadecimal, exactly 32 characters)"
			:rules="{ required: true, hexIv }"
			counter="32"
			@input="$emit('update:iv', $event)"
		/>
	</div>
</template>

<script>
import TextField from '../../../../../shared/components/text-field.vue'

export default {
	name: 'sales-force-credentials-form',

	components: {
		TextField
	},

	props: {
		secret: {
			type: String,
			default: ''
		},
		salt: {
			type: String,
			default: ''
		},
		iv: {
			type: String,
			default: ''
		}
	}
}
</script>
